export default "__VITE_ASSET__d52d2928__"